import { render, staticRenderFns } from "./RelationToInfo.vue?vue&type=template&id=04656184&scoped=true&"
import script from "./RelationToInfo.vue?vue&type=script&lang=ts&"
export * from "./RelationToInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04656184",
  null
  
)

export default component.exports